// Solução para sincronizar color swatches do Globo (Feather Bundle) com a foto principal do produto

(function() {
  'use strict';

  // Isolado só na página do Tulle Mesh Top (eleva-feather) - nao roda em nenhuma outra pagina
  if (window.location.pathname.indexOf('/products/eleva-feather') === -1) {
    return;
  }

  // Mapa cor -> imagem da variante (extraido direto do produto via Admin API)
  const colorImageMap = {
    'Black': 'https://cdn.shopify.com/s/files/1/0771/0434/9499/files/tulle-feather-black-1.jpg?v=1786834774',
    'Yellow Butter': 'https://cdn.shopify.com/s/files/1/0771/0434/9499/files/pose1_v2.jpg?v=1786889421',
    'Barolo': 'https://cdn.shopify.com/s/files/1/0771/0434/9499/files/tulle-feather-barolo-1.jpg?v=1786834805',
    'Carbox': 'https://cdn.shopify.com/s/files/1/0771/0434/9499/files/tulle-feather-carbox-1.jpg?v=1786834783',
    'Croco': 'https://cdn.shopify.com/s/files/1/0771/0434/9499/files/pose2_v2.jpg?v=1786835841',
    'Navy': 'https://cdn.shopify.com/s/files/1/0771/0434/9499/files/tulle-feather-navy-1.jpg?v=1786834793',
    'White': 'https://cdn.shopify.com/s/files/1/0771/0434/9499/files/tulle-feather-white-1.jpg?v=1786834854',
    'Cappucino': 'https://cdn.shopify.com/s/files/1/0771/0434/9499/files/tulle-feather-cappucino-1.jpg?v=1786834836',
    'Berry': 'https://cdn.shopify.com/s/files/1/0771/0434/9499/files/pose1_v2_13f672ca-a241-4c53-bba1-3208fd4be512.jpg?v=1786892500'
  };

  // Atualiza a foto principal (slide ativo da galeria) pra imagem da cor escolhida
  function updateMainImageForColor(colorName) {
    const newImageSrc = colorImageMap[colorName];
    if (!newImageSrc) {
      console.log('❌ Cor não mapeada:', colorName);
      return;
    }

    const productImage = document.querySelector('.product__media-item.is-active img.image-magnify-hover');
    if (!productImage) {
      console.log('❌ Imagem principal não encontrada');
      return;
    }

    const baseImagePath = newImageSrc.split('?')[0];
    const versionMatch = newImageSrc.split('v=')[1];
    const version = versionMatch ? versionMatch.split('&')[0] : '';

    const newSrc = baseImagePath + '?v=' + version + '&width=1946';
    const widths = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];
    const newSrcset = widths.map(width => {
      return `${baseImagePath}?v=${version}&width=${width} ${width}w`;
    }).join(', ');

    productImage.style.transition = 'opacity 0.2s ease';
    productImage.style.opacity = '0.5';

    setTimeout(() => {
      productImage.src = newSrc;
      productImage.srcset = newSrcset;
      productImage.style.opacity = '1';
      console.log('✅ Imagem principal atualizada para', colorName);
    }, 150);
  }

  // Listener para clicks nos swatches de cor do Feather Bundle (Quantity Break)
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('.gcw-quantity-break__offer-variant-swatch-color');
    if (!swatch) return;

    const colorName = swatch.getAttribute('data-value');
    console.log('👆 Swatch de cor clicado no bundle:', colorName);
    updateMainImageForColor(colorName);
  });

  console.log('Globo Bundle Image Sync: Ativado (eleva-feather, color swatch)');

})();
